import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";

type UnsavedChangesDialogProps = {
  open: boolean;
  // Called with false when the user decides to keep editing.
  onOpenChange: (open: boolean) => void;
  onDiscard: () => void;
  description: string;
};

/**
 * Shared by the column editor and the cell panel, where a click outside ends an
 * edit. A dialog rather than a notice inside the editor: the question is about
 * closing it, so it has to be answered first.
 */
export function UnsavedChangesDialog({
  open,
  onOpenChange,
  onDiscard,
  description,
}: UnsavedChangesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Discard changes?</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Keep editing
          </Button>
          <Button onClick={onDiscard}>Discard changes</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
